import { render, staticRenderFns } from "./AppCenter.vue?vue&type=template&id=61ef1f0e"
import script from "./AppCenter.vue?vue&type=script&lang=js"
export * from "./AppCenter.vue?vue&type=script&lang=js"
import style0 from "./AppCenter.vue?vue&type=style&index=0&id=61ef1f0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports